// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"668":"3e19ca6f","691":"3e19ca6f","966":"3e19ca6f","1931":"c7d8c058","2214":"fa9b8680","5264":"c7d8c058"}[chunkId] + ".chunk.css";
};